
/**
 * Verifica si el navegador permite el modo pantalla completa
 */
export const isFullScreenSupported = () => {
  return 'fullscreen' in document
    || 'webkitFullscreen' in document
    || 'mozFullScreen' in document
    || 'msFullscreenEnabled' in document;
}

/**
 * Activa el modo pantalla completa en un elemento específico (ej. el WebViewer)
 */
export const requestFullScreen = (element) => {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}

/**
 * Sale del modo pantalla completa
 */
export const exitFullScreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

/**
   * @returns {boolean} true si el documento está actualmente en modo pantalla completa
   */
export const isFullScreenActive = () => {
  return Boolean(
    document.fullscreenElement
    || document.webkitFullscreenElement
    || document.mozFullScreenElement
    || document.msFullscreenElement
  )
}
